import {  User } from "lucide-react";
import React, { useEffect, useState } from "react";

const Header = ({ toggleSidebar }) => {
  const [dateTime, setDateTime] = useState(new Date());
  const user = "Rohan Yadav";

  useEffect(() => {
    const interval = setInterval(() => {
      setDateTime(new Date());
    }, 1000); // update every second for accuracy

    return () => clearInterval(interval);
  }, []);

  const formattedDate = dateTime.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  const formattedTime = dateTime.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false, // 24-hour format
  });
  return (
    <header className="header">
      <div className="header-content">
        <button
          className="toggle-button"
          style={{ marginRight: "1rem" }}
          onClick={toggleSidebar}
        >
          ☰
        </button>
        <div className="header-actions">
          <span className="timestamp">
            {" "}
            {formattedDate}{" "}
            <span
              style={{ fontWeight: "500", fontSize: "20px", color: "#000" }}
            >
              |
            </span>{" "}
            {formattedTime}
          </span>
        </div>
        <div className="login_btn flex items-center gap-3">
          <div className="loggedInCard items-center gap-3">
            <div className="user_info">
              <div className="user_image">
                <User size={18} />
              </div>
              <div className="font-medium">{user}</div>
            </div>
            {/* <button onClick={handleLogout} className="logOUt_btn">
              <LogOut size={24} />
            </button> */}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
